import React, { useEffect, useState } from "react";
import { LoginModal, useAuth } from "@dfds-platform/business-components";
import { EventEmitter } from "@angular/core";
import { OktaDetails } from "./okta.service";

interface Props {
    onSubmitted: EventEmitter<any>;
    onLoggingOut: EventEmitter<any>;
    onAuthenticate: EventEmitter<OktaDetails>;
}

const OktaLogin = (props: Props) => {
    const [open, setOpen] = useState<boolean>(false);
    const { authApi, isLoggedIn, isAuthenticated, currentUser } = useAuth();

    useEffect(() => {
        props.onSubmitted.subscribe((data: any) => {
            setOpen(true);
        });

        props.onLoggingOut.subscribe((data: any) => {
            authApi.logout();
        });
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            props.onAuthenticate.emit({
                user: currentUser && currentUser.email,
                loggedIn: true,
            });
        }

        if (!isLoggedIn) {
            props.onAuthenticate.emit({
                user: "",
                loggedIn: false,
            });
        }
        setOpen(false);
    }, [isLoggedIn]);

    return (
        <LoginModal
            sizes={{
                s: "fullscreen",
                m: "350px",
                l: "350px",
                xl: "350px",
                xxl: "350px",
            }}
            data-e2e="login-modal"
            modalOpen={open}
            onModalClose={() => setOpen(false)}
        ></LoginModal>
    );
};

export default OktaLogin;
